'use client';

import { c } from '../../../utils/tailwind-merge';
import type { SwitchProps } from './Switch.types';

export const Switch = ({
  checked,
  disabled = false,
  id,
  ariaLabel,
  ariaLabelledBy,
  onCheckedChange,
  testId,
  className = '',
}: SwitchProps) => {
  return (
    <button
      type="button"
      role="switch"
      id={id}
      aria-checked={checked}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledBy}
      disabled={disabled}
      data-state={checked ? 'checked' : 'unchecked'}
      data-test={testId}
      onClick={() => onCheckedChange(!checked)}
      className={c(
        'relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors',
        "after:absolute after:-inset-y-2.5 after:inset-x-0 after:content-['']",
        'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus',
        checked ? 'bg-accent' : 'bg-grey-600',
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
        className
      )}
    >
      <span
        aria-hidden="true"
        className={c(
          'pointer-events-none block size-5 rounded-full bg-white shadow transition-transform',
          checked ? 'translate-x-[22px]' : 'translate-x-0.5'
        )}
      />
    </button>
  );
};

Switch.displayName = 'Switch';
